import { Box } from "@mui/material";
import React from "react";

export default function TestPage() {
  return (
    <Box sx={{ height: "400px", width: "400px", textAlign: "center" }}>
      There's nothing here 🫠
    </Box>
  );
}
